import {createBrowserRouter, Navigate, RouterProvider} from 'react-router-dom';
import { getPlayers } from 'API/v1/GetPlayers';
import { getAllPlayers } from 'API/v1/admin/GetAllPlayers';
import M3UManager from 'components/admin/M3UManager';
import PlayerHealthTimeline from 'components/admin/PlayerHealthTimeline';
import UserManager from 'components/admin/UserManager';
import ChannelsView from 'components/channels/ChannelsView';
import AllPlayerTable from 'components/player/AllPlayerTable';
import PlayerTable from 'components/player/PlayerTable';
import AdminRoute from 'components/router/AdminRoute';
import PrivateRoute from 'components/router/PrivateRoute';
import PublicRoute from 'components/router/PublicRoute';
import UserRoute from 'components/router/UserRoute';
import {LOGIN, LOGOUT, PRIVATE_USER_PLAYERS, PRIVATE, PRIVATE_USER, PRIVATE_ADMIN, PRIVATE_ADMIN_PLAYERS, PRIVATE_ADMIN_USERS, PRIVATE_ADMIN_M3US, PRIVATE_ADMIN_PLAYER_HEALTH, PRIVATE_USER_CHANNELS} from 'config/router/paths';
import AuthContextProvider from 'contexts/authContext';
import { AppThemeProvider } from 'contexts/themeContext';
import Login from 'views/Login';
import Logout from 'views/Logout';
import PrivateRedirector from 'views/PrivateRedirector';
import PublicRedirector from 'views/PublicRedirector';

// Check if required environment variables are set
if (
  !process.env.REACT_APP_BACKEND_URL ||
  !process.env.REACT_APP_TOKEN_NAME ||
  !process.env.REACT_APP_REFRESH_TOKEN_NAME
) {
  throw new Error("Missing required environment variable.");
}

const router = createBrowserRouter([
  {
    path: PRIVATE,
    element: <PrivateRoute />,
    children: [
      {
        index: true,
        element: <PrivateRedirector />
      },
      {
        path: PRIVATE_USER,
        element: <UserRoute />,
        children: [
          {
            path: PRIVATE_USER_PLAYERS,
            loader: () => getPlayers(),
            element: <PlayerTable />
          },
          {
            path: PRIVATE_USER_CHANNELS + '/:groupName',
            element: <ChannelsView />
          }
        ]
      },
      {
        path: PRIVATE_ADMIN,
        element: <AdminRoute />,
        children: [
          {
            index: true,
            element: <Navigate to={PRIVATE_ADMIN_M3US} replace />
          },
          {
            path: PRIVATE_ADMIN_PLAYERS,
            loader: () => getAllPlayers(),
            element: <AllPlayerTable />
          },
          {
            path: PRIVATE_ADMIN_USERS,
            element: <UserManager />
          },
          {
            path: PRIVATE_ADMIN_M3US,
            element: <M3UManager />
          },
          {
            path: PRIVATE_ADMIN_PLAYER_HEALTH,
            element: <PlayerHealthTimeline />
          }
        ]
      },
      {
        path: LOGOUT,
        element: <Logout />
      }
    ]
  },
  {
    path: '/',
    element: <PublicRoute />,
    children: [
      {
        index: true,
        element: <PublicRedirector />
      },
      {
        path: LOGIN,
        element: <Login />
      }
    ]
  }
], {basename: process.env.PUBLIC_URL});

function App() {
  return (
    <AppThemeProvider>
      <AuthContextProvider>
        <RouterProvider router={router} />
      </AuthContextProvider>
    </AppThemeProvider>
  );
}

export default App;
